export default __webpack_public_path__ + "static/media/Animals_32.53352e28.png";